import "./appinitandstate/TocAvailabilityNotice.css";
import { SongsAvailability } from "./appinitandstate/SongsAvailability";
import { BackendServerAvailability } from "./appinitandstate/BackendServerAvailability";
import Auth from "./auth/Auth";
import { OfflineUpdateSummary } from "./offline/OfflineUpdateSummary";
import { useStateWithLocalStoragePersistenceAndDefault } from "./common/hooks/useStateWithLocalStoragePersistenceAndDefault";
import { HomeLocalStorageKeys } from "./HomeLocalStorageKeys";
import { Container } from "reactstrap";
import { PlaylistIndex } from "./playlists/PlaylistIndex";
import { useState } from "react";
import MainMenu from "./menuandheader/MainMenu";
import OfflineComponentsHolder from "./offline/OfflineComponentsHolder";
import { NoCrewMembershipFoundAlert } from "./crew/NoCrewMembershipFoundAlert";
import { LookupSongFunction } from "./common/LookupSongFunction";

interface Props {
  auth: Auth;
  tocAvailability: SongsAvailability;
  backendServerAvailability: BackendServerAvailability;
  startUpdate: () => void;
  resetProgress: () => void;
  offlineUpdateSummary: OfflineUpdateSummary;
  lookupSong: LookupSongFunction;
  downloadOfFilesNecessary: boolean;
}

export default function Home(props: Props) {
  //also read / written in Playlist component
  const [currentCrewIdentifier, setCurrentCrewIdentifier] =
    useStateWithLocalStoragePersistenceAndDefault<string | undefined>(
      HomeLocalStorageKeys.currentCrewIdentifierKey,
      undefined,
    );

  const [isMainMenuOpen, setIsMainMenuOpen] = useState(false);
  return (
    <>
      <MainMenu
        isMainMenuOpen={isMainMenuOpen}
        setIsMainMenuOpen={setIsMainMenuOpen}
      />

      <Container fluid={true}>
        <NoCrewMembershipFoundAlert />

        <OfflineComponentsHolder
          currentBackendServerAvailability={props.backendServerAvailability}
          resetProgress={props.resetProgress}
          startUpdate={props.startUpdate}
          offlineUpdateSummary={props.offlineUpdateSummary}
          downloadOfFilesNecessary={props.downloadOfFilesNecessary}
        />

        <PlaylistIndex
          lookupSong={props.lookupSong}
          currentCrewIdentifier={currentCrewIdentifier}
          setCurrentCrewIdentifier={setCurrentCrewIdentifier}
          setIsMainMenuOpen={setIsMainMenuOpen}
        />
      </Container>
    </>
  );
}
